import {
  // 单选、多选组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  // 单选榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 多选榜单筛选器
  MULTIPLE_SOURCE_SELECT as MULTIPLE_SOURCE_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { COMPARE_MOBILE_SOURCES, DEFAULT_DATASOURCES } from '../../StoreRank/config';

export const DEFAULT_SINGLE_COUNTRY = 'us';

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  // 单选、多选组合国家筛选器
  COMPOSED_COUNTRY_SELECT_FILTER: {
    key: COMPOSED_COUNTRY_SELECT_FILTER,
    type: COMPOSED_COUNTRY_SELECT_FILTER,
    visible: 1,
    disabled: false,
    isAll: false,
    defaultSingleCountry: DEFAULT_SINGLE_COUNTRY,
  },
  // 单选榜单筛选器
  SINGLE_SOURCE_SELECT_FILTER: {
    key: SINGLE_SOURCE_SELECT_FILTER,
    type: SINGLE_SOURCE_SELECT_FILTER,
    visible: 1,
    disabled: false,
    isShowButtonLabel: false,
    entityType: 'mobile',
    sources: COMPARE_MOBILE_SOURCES,
  },
  // 多选榜单筛选器
  MULTIPLE_SOURCE_SELECT_FILTER: {
    key: MULTIPLE_SOURCE_SELECT_FILTER,
    type: MULTIPLE_SOURCE_SELECT_FILTER,
    visible: 2,
    disabled: false,
    isShowButtonLabel: true,
    entityType: 'mobile',
    sources: COMPARE_MOBILE_SOURCES,
  },
  // 是否显示热度国家筛选器
  HEAT_MAP_SELECT_FILTER: {
    key: HEAT_MAP_SELECT_FILTER,
    type: HEAT_MAP_SELECT_FILTER,
    visible: 1,
    disabled: false,
    isShowTypeSelect: true,
    options: [],
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  // 单选、多选组合国家筛选器
  [COMPOSED_COUNTRY_SELECT_FILTER]: {
    value: {
      type: 'multiple',
      countries: [],
    },
  },
  // 单选榜单筛选器
  [SINGLE_SOURCE_SELECT_FILTER]: {
    value: COMPARE_MOBILE_SOURCES?.[0],
  },
  // 多选榜单筛选器
  [MULTIPLE_SOURCE_SELECT_FILTER]: {
    value: DEFAULT_DATASOURCES,
  },
  // 是否显示热度国家筛选器
  [HEAT_MAP_SELECT_FILTER]: {
    value: false,
  },
};
